import { render } from "./aging-report.vue?vue&type=template&id=a43ab67e"
import script from "./aging-report.vue?vue&type=script&lang=js"
export * from "./aging-report.vue?vue&type=script&lang=js"

import "./aging-report.vue?vue&type=style&index=0&id=a43ab67e&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__